'use client'
import { notFoundImage as Icon_notFoundImage } from "@/components/customer/icons/notFoundImage";
const SvgIcons = { notFoundImage: Icon_notFoundImage };
import { NextPage } from 'next';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

// Somewhere a visitor can actually go. A 404 with a single "Back to Home" button makes the
// dead end the visitor's problem; these are the pages they were most likely looking for.
const QUICK_LINKS = [
  { href: '/growsuite', label: 'GrowSuite CRM & HRM' },
  { href: '/vilvachat-official-whatsapp-business-api', label: 'VilvaChat for WhatsApp' },
  { href: '/business-websites', label: 'Business Websites' },
  { href: '/viewplan', label: 'Pricing' },
  { href: '/blog', label: 'Blog' },
  { href: '/contact-us', label: 'Contact Us' },
];

const NotFound: NextPage = () => {
  return (
    <>
      <Navbar />
      {/* Footer is `lg:sticky ... z-0` (components/Footer.tsx:35), so page content has to sit in
          its own stacking context above it — every other page does this with the same
          `bg-white z-30 relative` wrapper. Without it the sticky footer paints straight over
          this page's text on short viewports. */}
      <div className="bg-white z-30 relative">
      <div className="md:container px-2 md:px-0">
        {/* Was h-screen, which pushed the footer a full viewport down on every 404. */}
        <div className="flex justify-center items-center py-[80px] md:py-[120px]">
          <div>
            <div className='mx-auto w-full flex justify-center'> <SvgIcons.notFoundImage /></div>

            <p className="text-[#090D28] mt-6 text-center font-Schibsted_Grotesk text-[20px] font-semibold leading-[100%]">
              This page took a wrong turn - unlike your business.
            </p>

            {/* The data-aos attributes that used to sit on these two spans held them at
                opacity:0 until hydration — so the button rendered as an empty blue pill and
                the sentence lost its last two words. On an error page, which people reach
                with low patience, that is the worst place to gamble on JavaScript. */}
            <p className="text-[#444864] text-center font-Schibsted_Grotesk text-[16px] font-normal leading-[120%] my-4">
              success is just one click away with <span>Vilva Business.</span>
            </p>

            <Link
              href="/"
              className="text-white font-Schibsted_Grotesk text-[16px] font-normal leading-[120%] rounded-[8px] bg-[#195AFF] flex h-[40px] w-fit mx-auto px-[24px] justify-center items-center hover:bg-[#1449CC] transition-colors"
            >
              Back to Home
            </Link>

            <div className="mt-10 max-w-2xl mx-auto">
              <p className="text-[#717171] text-center font-Schibsted_Grotesk text-[14px] mb-4">
                Or jump straight to one of these:
              </p>
              <ul className="flex flex-wrap justify-center gap-2">
                {QUICK_LINKS.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="inline-flex min-h-[44px] items-center rounded-[8px] border border-[#CEDFFE] bg-[#F7FAFF] px-4 py-2 font-Schibsted_Grotesk text-[15px] text-[#0B1535] transition-colors hover:border-[#195AFF] hover:text-[#195AFF]"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
